<template>
  <div class="group-list">
    <div class="container-fluid">
      <div class="table-responsive margin-Top-6Perc overflow-x-hidden">
        <table class="table table-striped ">
          <thead>
            <tr>
              <!-- <th class="text-align-center font-size-15px"></th> -->
              <th class="text-align-center font-size-15px border-right">Master Courses</th>
              <th class="text-align-center font-size-15px border-right">Subtitle</th>
              <th class="text-align-center font-size-15px border-right">Associate</th>
              <th class="text-align-center font-size-15px border-right">Is Elective</th>
              <th class="text-align-center font-size-15px border-right">Cohort Names</th>
              <!-- <th class="text-align-center font-size-15px">Action</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="courseObj in getCourseList" :key="courseObj.GroupId" v-bind:courseObj = "courseObj" >
              <!-- <td>
                <input type="checkbox" name="groupDetails" :checked="grp.isSelected">
              </td> --> 
              <td class="border-right">{{courseObj.CourseTitle}}</td>
              <td class="border-right">{{courseObj.SubTitle }}</td>
              <td class="border-right">
                <div class="checkbox">
                  <label><input type="checkbox" value="" @click="AssociateGroup(courseObj.CourseMasterId)"></label>
                </div>
              </td>
              <td class="border-right">
                <div class="checkbox">
                  <label><input type="checkbox" value=""></label>
                </div>
              </td>
              <td class="">
                  <input type="text" class="form-control" id="usr">
              </td>
              <!-- <td class="border-right cursor-pointer text-decoration-underline">{{groupObj.CourseTitle}} Course</td> -->
              <!--
              <td>
                <a href="#"> Edit </a>|
                <a href="#"> View </a>|
                <a href="#"> Activity </a>|
                <a href="#"> Reports </a>|
                <a href="#"> Participants </a>
              </td>
              -->
            </tr>
          </tbody>
       </table>
    </div>
  </div>
  <!-- Show Spinner -->
  <div class="animationload" v-show="showSpinner">
    <div class="osahanloading"></div>
  </div>
  <loader></loader>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
</div>
</template>
<script>
import { constants } from '@/utils/constants'
import { groupService } from '@/server-util/group-service'
import { cohortService } from '@/server-util/cohort-service'
import { participantService } from '@/server-util/participant-service'
import AlertBox from '@/components/AlertOverlay'
import ViewEnrolledCourseList from '@/components/ViewEnrolledCourseListUsingGroup'
import ViewEnrolledCohortList from '@/components/ViewEnrolledCohortListUsingGroup'
import ViewEnrolledParticipantList from '@/components/ViewEnrolledParticipantListUsingGroup'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import Loader from '@/components/dashboard/Loader'
import filter from 'lodash/filter'
export default {
  // props: ['groupList'],
  computed: {
    getCourseList: {
      get: function () {
        console.log('course list', JSON.stringify(this.$store.state.course_list))
        return this.$store.state.course_list
      }
    }
  },
  data: function () {
    return {
      isChecked: false,
      groupDetails: [],
      viewEnrolledCourses: false,
      viewEnrolledCohorts: false,
      viewEnrolledParticipants: false,
      selectedGroupObj: null,
      enrolledCourseList: [],
      enrolledCohortList: [],
      enrolledParticipantList: [],
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      compareArray: []
    }
  },
  name: 'group-list',
  methods: {
    AssociateGroup: function (courseId) {
      // console.log('Print Course Id', courseId)
      this.compareArray = filter(this.getCourseList, (obj) => {
        // console.log('Print object ' courseId)
        return parseInt(obj.CourseMasterId) === (courseId)
        // return parseInt(obj.CourseType) === (this.courseType)
      })
      console.log('campare array', JSON.stringify(this.compareArray))
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    viewCourseList: function (event, flagToUpdate, selectedGroupObj) {
      // this.viewEnrolledCourses = flagToUpdate
      this.selectedGroupObj = selectedGroupObj
      if (selectedGroupObj.CourseCount === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'No course found in \'' + selectedGroupObj.GroupName + '\'.'
        return
      }
      this.getEnrolledCourses()
    },
    viewCohortList: function (event, flagToUpdate, selectedGroupObj) {
      // this.viewEnrolledCourses = flagToUpdate
      this.selectedGroupObj = selectedGroupObj
      if (selectedGroupObj.CohortCount === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'No cohort found in \'' + selectedGroupObj.GroupName + '\'.'
        return
      }
      this.getEnrolledCohorts()
    },
    viewParticipantList: function (event, flagToUpdate, selectedGroupObj) {
      // this.viewEnrolledCourses = flagToUpdate
      this.selectedGroupObj = selectedGroupObj
      if (selectedGroupObj.ParticipantCount === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'No participant found in \'' + selectedGroupObj.GroupName + '\'.'
        return
      }
      this.getEnrolledParticipants()
    },
    updateViewEnrolledCoursesFlag (value) {
      // AK: used to close the overlay (view enrolled courses page) by pressing Close
      this.viewEnrolledCourses = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateViewEnrolledCohortsFlag (value) {
      // AK: used to close the overlay (view enrolled cohort page) by pressing Close
      this.viewEnrolledCohorts = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateViewEnrolledParticipantsFlag (value) {
      // AK: used to close the overlay (view enrolled Participant page) by pressing Close
      this.viewEnrolledParticipants = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    getEnrolledCourses: function () {
      var storeObj = this.$store
      var _this = this
      // alert(this.LessonObj.ModuleId)
      if (
        this.selectedGroupObj.GroupId !== undefined ||
        this.selectedGroupObj.GroupId !== null
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        groupService
          .getCourseList(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Assign it to enrolledCourseList
                this.enrolledCourseList = responseObj.data
                // AK: Hide Spinner after recieving Enrolled course list and show overlay
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                _this.viewEnrolledCourses = true
                // AK: Disable Background Scrolling
                this.$store.state.isOverlayVisible = true

                // console.log(JSON.stringify(this.enrolledCourseList))
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'GroupId is NULL hence declined LOADING ENROLLED COURSE LIST OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getEnrolledCohorts: function () {
      var storeObj = this.$store
      var _this = this
      // alert(this.LessonObj.ModuleId)
      if (
        this.selectedGroupObj.GroupId !== undefined ||
        this.selectedGroupObj.GroupId !== null
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortList(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Assign it to enrolledCohortList
                this.enrolledCohortList = responseObj.data
                // AK: Hide Spinner after recieving Enrolled Cohort list and show overlay
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                _this.viewEnrolledCohorts = true
                // AK: Disable Background Scrolling
                this.$store.state.isOverlayVisible = true
                // console.log(JSON.stringify(this.enrolledCohortList))
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'GroupId is NULL hence declined LOADING ENROLLED COHORT LIST OPERATION'
        )
      }
    },
    getEnrolledParticipants: function () {
      var storeObj = this.$store
      var _this = this
      // alert(this.LessonObj.ModuleId)
      if (
        this.selectedGroupObj.GroupId !== undefined ||
        this.selectedGroupObj.GroupId !== null
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        participantService
          .getParticipantList(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Assign it to enrolledCourseList
                this.enrolledParticipantList = responseObj.data
                // AK: Hide Spinner after recieving Enrolled course list and show overlay
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                _this.viewEnrolledParticipants = true
                // AK: Disable Background Scrolling
                this.$store.state.isOverlayVisible = true
                // console.log(JSON.stringify(this.enrolledParticipantList))
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
      } else {
        console.log(
          'GroupId is NULL hence declined LOADING ENROLLED COURSE LIST OPERATION'
        )
      }
    }
    /* selectAll () {
      this.isChecked = true
      this.updateGroupDetails()
    },
    deSeclectAll () {
      this.isChecked = false
      this.updateGroupDetails()
    }
    ,
    updateGroupDetails () {
      console.log('UPDATE GROUP DETAILS')
      for (var ii = 0; ii < this.groupDetails.length; ii++) {
        console.log(this.groupDetails[ii])
        this.groupDetails[ii].isSelected = this.isChecked
      }
    } */
  },
  components: {
    'view-enrolled-courses': ViewEnrolledCourseList,
    'alert-box': AlertBox,
    'view-enrolled-cohorts': ViewEnrolledCohortList,
    'view-enrolled-participants': ViewEnrolledParticipantList,
    'loader': Loader
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}

.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.group-list {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}

.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
</style>


// WEBPACK FOOTER //
// src/components/GroupCourseBatchList.vue